import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMCourierServiceAsync,
  deleteOMCourierServiceAsync,
  editOMCourierServiceAsync,
  getOMCourierServiceAsync,
} from "../../../store/services/orderManagementService";
const CourierService = () => {
  const dispatch = useDispatch();
  const {
    getOMCourierServiceStatus,
    getOMCourierServiceError,
    getOMCourierServiceData,
    addOMCourierServiceStatus,
    addOMCourierServiceData,
    addOMCourierServiceError,

    editOMCourierServiceStatus,
    editOMCourierServiceError,
    editOMCourierServiceData,

    deleteOMCourierServiceData,
    deleteOMCourierServiceStatus,
    deleteOMCourierServiceError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMCourierServiceAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMCourierServiceData?.length
    ? getOMCourierServiceData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedCourierService, setSelectedCourierService] = useState();
  const [addCourierServiceMode, setAddCourierServiceMode] = useState(false);
  const [addCourierServiceData, setAddCourierServiceData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedCourierService", selectedCourierService);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMCourierServiceStatus === asyncStatus.SUCCEEDED) {
      setAddCourierServiceMode(false);
      setSaveDisabled(true);
      setAddCourierServiceData();
    }
  }, [, addOMCourierServiceStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMCourierServiceAsync(selectedCourierService?.courier_service_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMCourierServiceStatus === asyncStatus.SUCCEEDED || deleteOMCourierServiceStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedCourierService();
    }
  }, [, deleteOMCourierServiceStatus]);
  useEffect(() => {
    if (editOMCourierServiceStatus === asyncStatus.SUCCEEDED) {
      setSelectedCourierService();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMCourierServiceStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this courier service?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Courier Service"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Courier Service
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddCourierServiceMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addCourierServiceMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addCourierServiceMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddCourierServiceMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addCourierServiceMode || !selectedCourierService}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMCourierServiceStatus === asyncStatus.LOADING ||
                  editOMCourierServiceStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addCourierServiceData) {
                    dispatch(addOMCourierServiceAsync(addCourierServiceData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedCourierService, ...editData };
                    delete a.id;
                    dispatch(editOMCourierServiceAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "courier_service_id", headerName: "ID", flex: true },
                  { field: "service_name", headerName: "Courier Service", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedCourierService(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMCourierServiceStatus === asyncStatus.IDLE ||
                  getOMCourierServiceStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addCourierServiceMode ? (
              <InputWithBtnLayoutComp
              error={addOMCourierServiceError}
                inputArray={[
                  {
                    label: "Courier Service:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddCourierServiceData({
                            ...addCourierServiceData,
                            service_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddCourierServiceData({
                            ...addCourierServiceData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedCourierService ? (
              <InputWithBtnLayoutComp
              error={editOMCourierServiceError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedCourierService?.courier_service_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "CourierService:",
                    comp: (
                      <InputComp
                        key={selectedCourierService?.courier_service_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            service_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedCourierService?.service_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedCourierService?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedCourierService?.is_active || editData?.is_active}
                        defaultChecked={selectedCourierService?.is_active || editData?.is_active}
                        // checked={selectedCourierService?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any courier service</Typography>
              <Typography color={"red"} fontSize={12}>{getOMCourierServiceError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedCourierService(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedCourierService(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default CourierService;
